
export default {
  isFudaoConnected(state, getters, rootState, rootGetters) {
    if (!state.fudaoDto || !state.fudaoDto.id) {
      return false;
    }
    return true;
  },

  isFudaoTeacher(state, getters, rootState, rootGetters) {
    let fudaoDto = state.fudaoDto;
    if (!fudaoDto.teacher || !fudaoDto.student) {
      return null;
    }

    return fudaoDto.teacher.Id === rootState.userid ? true : false;
  },

  isFudaoStudent(state, getters, rootState, rootGetters) {
    let fudaoDto = state.fudaoDto;
    if (!fudaoDto.teacher || !fudaoDto.student) {
      return null;
    }

    return fudaoDto.student.Id === rootState.userid ? true : false;
  }
};
